import { useMemo } from 'react';
import { useMqttSubscription } from '@hooks/mqtt/useMqttSubscription';
import { SiteMeta } from '@src/types/SiteMeta';
import { ControlModes } from '@src/types/Stacks';
import { ControlAuthorities } from '@src/types/ControlModes';
import {
  generateStatusTypes,
  extractStatusValues,
} from '../helpers/statusHelpers';
import { TemplateStatusValues } from '../types';

export const useTemplateStatus = (
  controlMode: ControlModes,
  siteMeta: SiteMeta,
  controlAuthority: ControlAuthorities | undefined | null,
  alias: (key: string) => string,
): TemplateStatusValues => {
  const statusTypes = useMemo(
    () =>
      generateStatusTypes(
        controlMode.name,
        controlAuthority,
        alias,
        siteMeta.siteId,
      ),
    [controlMode.name, controlAuthority, alias, siteMeta.siteId],
  );

  const { data: values } = useMqttSubscription(
    statusTypes.map((st) => st.topic),
  );

  const { scadaStatus, activeStatus, hmiStatus } = useMemo(
    () => extractStatusValues(statusTypes, values),
    [statusTypes, values],
  );

  return {
    scadaStatus,
    hmiStatus,
    activeStatus,
    statusTypes,
  };
};
